
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Eigentlich stimmt alles: Ferienstimmung, nettes Hotel, flauschiges Bett. Und doch fühlen wir uns nach der ersten Nacht nicht ausgeschlafen. Besonders Menschen, die auch zu Hause schlecht schlafen, kommen in Hotels noch weniger zur Ruhe. In der Schlafforschung spricht man in solchen Fällen vom First-Night-Effect. Gemäss Wissenschaftlern aus den USA tritt dieser auf, weil unser Gehirn in einer neuen Umgebung auch im Schlaf aktiv bleibt – ohne dass wir es merken. `}<M mdxType="M">{`Versuche haben gezeigt, dass in solchen «ersten Nächten» die linke Hirnhälfte wachsam bleibt, während sich in der rechten Hälfte alles ganz normal verhält.`}</M>{` Die linke Seite wird so zu einer Art Nachtwächter; bei Gefahr könnten wir dank ihr schnell reagieren. Dieser Schutz ist aus heutiger Sicht natürlich nicht mehr zwingend nötig. Es handelt sich dabei wohl auch hier um ein Relikt aus der Steinzeit, als diese Vorsicht und Wachsamkeit noch überlebenswichtig waren. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;